export default "// fragment shader\nuniform vec3 color;\n\n\nvoid main(void) {\n    gl_FragColor = vec4( color, 1.0);\n}";